import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../containers/Layout';
import Blog from '../containers/Blog';

const BlogPage = ({ _, location, data }) => {
  return (
    <Layout title="Tycoon Blog" location={location.href} >
      <Blog
        featuredPost={data.posts.featuredPost}
        popularPosts={data.posts.allPublishedPosts}
        tycoonPosts={data.posts.tycoonPosts}
        randomShuffledPosts={data.posts.shuffledPosts}
        videoPosts={data.posts.videoPosts}
      />
    </Layout>
  );
};

export const query = graphql`
  query BlogPosts {
    posts {
      videoPosts(sortBy: "post_date", order: "DESC", from: 0, limit: 3) {
        post_date
        title
        category
        video_post_id
        video_url
      }
      featuredPost {
        post_id
        title
        category
        publish_date
        is_featured
      }
      shuffledPosts(limit: 5) {
        post_id
        title
        category
        publish_date
      }
      tycoonPosts {
        post_id
        title
        category
        publish_date
      }
      allPublishedPosts(sortBy: "popularity_count", order: "DESC", from: 0, limit: 5) {
        post_id
        title
        category
        publish_date
      }
    }
  }
`;

export default BlogPage;
